import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const Visibility1: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <g clipPath="url(#clip0_1621_91137)">
        <path d="M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 16C14.4853 16 16.5 13.9853 16.5 11.5C16.5 11.3419 16.4918 11.1857 16.4759 11.0318C16.0186 11.6209 15.3036 12 14.5 12C13.1193 12 12 10.8807 12 9.5C12 8.49829 12.5891 7.63419 13.4398 7.23527C12.9878 7.0827 12.5035 7 12 7C9.51472 7 7.5 9.01472 7.5 11.5C7.5 13.9853 9.51472 16 12 16Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_91137">
          <rect width="24" height="24" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default Visibility1;
